module.exports = __webpack_public_path__ + "media/images/products/at1/at1-1-200x200-a6ed4faf64139779a484e268dd2aac9e.png";